var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({staticClass:"d-flex align-start"},'span',attrs,false),on),[(_vm.code != null)?[_c('span',{class:[
            'px-2',
            'py-1',
            'font-weight-bold',
            _vm.textColor,
            'text--darken-2',
            'd-flex',
            'align-center',
          ],style:({
            backgroundColor: _vm.backgroundColor,
            borderRadius: '8px',
            maxWidth: '220px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          })},[_c('v-icon',{class:['mr-1', _vm.textColor, 'text--darken-2'],staticStyle:{"font-weight":"bold"},attrs:{"left":"","size":"18"}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"text-truncate",staticStyle:{"flex":"1"}},[_vm._v(" "+_vm._s(_vm.date)+" ")])],1)]:[_c('span',{staticClass:"d-flex align-center justify-start"},[_c('span',{staticClass:"text-truncate",staticStyle:{"flex":"1"}},[_vm._v(" "+_vm._s(_vm.date)+" ")])])]],2)]}}])},[_c('span',[(_vm.code != null)?_c('b',[_vm._v(_vm._s(_vm.tooltipMessage))]):[_c('small',[_vm._v(_vm._s(_vm.date))])]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }